module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am565-8884d871e561829b01ea3f9ae9d509d1.jpg";